'use client';

/**
 * This file was automatically generated by the Stencil React Output Target.
 * Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 */

/* eslint-disable */

import { type OnAnswerGeneratedCallbackProps, type OnAnswerSourceClickCallbackProps, type OnChatMarkdownLinkClickedCallbackProps, type OnSearchCompletedCallbackProps, type OnSearchResultClickCallbackProps, type OramaChatBoxCustomEvent, type OramaChatCustomEvent, type OramaChatMessagesContainerCustomEvent, type OramaMarkdownCustomEvent, type OramaSearchBoxCustomEvent, type OramaSearchCustomEvent, type OramaSearchResultsCustomEvent, type OramaSourcesCustomEvent, type onStartConversationCallbackProps } from "@orama/wc-components";
import { OramaButton as OramaButtonElement, defineCustomElement as defineOramaButton } from "@orama/wc-components/dist/components/orama-button.js";
import { OramaChatAssistentMessage as OramaChatAssistentMessageElement, defineCustomElement as defineOramaChatAssistentMessage } from "@orama/wc-components/dist/components/orama-chat-assistent-message.js";
import { OramaChatBox as OramaChatBoxElement, defineCustomElement as defineOramaChatBox } from "@orama/wc-components/dist/components/orama-chat-box.js";
import { OramaChatButton as OramaChatButtonElement, defineCustomElement as defineOramaChatButton } from "@orama/wc-components/dist/components/orama-chat-button.js";
import { OramaChatMessagesContainer as OramaChatMessagesContainerElement, defineCustomElement as defineOramaChatMessagesContainer } from "@orama/wc-components/dist/components/orama-chat-messages-container.js";
import { OramaChatUserMessage as OramaChatUserMessageElement, defineCustomElement as defineOramaChatUserMessage } from "@orama/wc-components/dist/components/orama-chat-user-message.js";
import { OramaChat as OramaChatElement, defineCustomElement as defineOramaChat } from "@orama/wc-components/dist/components/orama-chat.js";
import { OramaDotsLoader as OramaDotsLoaderElement, defineCustomElement as defineOramaDotsLoader } from "@orama/wc-components/dist/components/orama-dots-loader.js";
import { OramaEmbed as OramaEmbedElement, defineCustomElement as defineOramaEmbed } from "@orama/wc-components/dist/components/orama-embed.js";
import { OramaFacets as OramaFacetsElement, defineCustomElement as defineOramaFacets } from "@orama/wc-components/dist/components/orama-facets.js";
import { OramaFooter as OramaFooterElement, defineCustomElement as defineOramaFooter } from "@orama/wc-components/dist/components/orama-footer.js";
import { OramaInput as OramaInputElement, defineCustomElement as defineOramaInput } from "@orama/wc-components/dist/components/orama-input.js";
import { OramaLogoIcon as OramaLogoIconElement, defineCustomElement as defineOramaLogoIcon } from "@orama/wc-components/dist/components/orama-logo-icon.js";
import { OramaMarkdown as OramaMarkdownElement, defineCustomElement as defineOramaMarkdown } from "@orama/wc-components/dist/components/orama-markdown.js";
import { OramaModal as OramaModalElement, defineCustomElement as defineOramaModal } from "@orama/wc-components/dist/components/orama-modal.js";
import { OramaNavigationBar as OramaNavigationBarElement, defineCustomElement as defineOramaNavigationBar } from "@orama/wc-components/dist/components/orama-navigation-bar.js";
import { OramaSearchBox as OramaSearchBoxElement, defineCustomElement as defineOramaSearchBox } from "@orama/wc-components/dist/components/orama-search-box.js";
import { OramaSearchButton as OramaSearchButtonElement, defineCustomElement as defineOramaSearchButton } from "@orama/wc-components/dist/components/orama-search-button.js";
import { OramaSearchResults as OramaSearchResultsElement, defineCustomElement as defineOramaSearchResults } from "@orama/wc-components/dist/components/orama-search-results.js";
import { OramaSearch as OramaSearchElement, defineCustomElement as defineOramaSearch } from "@orama/wc-components/dist/components/orama-search.js";
import { OramaSlidingPanel as OramaSlidingPanelElement, defineCustomElement as defineOramaSlidingPanel } from "@orama/wc-components/dist/components/orama-sliding-panel.js";
import { OramaSources as OramaSourcesElement, defineCustomElement as defineOramaSources } from "@orama/wc-components/dist/components/orama-sources.js";
import { OramaSuggestions as OramaSuggestionsElement, defineCustomElement as defineOramaSuggestions } from "@orama/wc-components/dist/components/orama-suggestions.js";
import { OramaText as OramaTextElement, defineCustomElement as defineOramaText } from "@orama/wc-components/dist/components/orama-text.js";
import { OramaTextarea as OramaTextareaElement, defineCustomElement as defineOramaTextarea } from "@orama/wc-components/dist/components/orama-textarea.js";
import { OramaToggler as OramaTogglerElement, defineCustomElement as defineOramaToggler } from "@orama/wc-components/dist/components/orama-toggler.js";
import type { EventName, StencilReactComponent } from '@stencil/react-output-target/runtime';
import { createComponent } from '@stencil/react-output-target/runtime';
import React from 'react';

export type OramaButtonEvents = NonNullable<unknown>;

export const OramaButton: StencilReactComponent<OramaButtonElement, OramaButtonEvents> = /*@__PURE__*/ createComponent<OramaButtonElement, OramaButtonEvents>({
    tagName: 'orama-button',
    elementClass: OramaButtonElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaButtonEvents,
    defineCustomElement: defineOramaButton
});

export type OramaChatEvents = {
    onAnswerGenerated: EventName<OramaChatCustomEvent<OnAnswerGeneratedCallbackProps>>,
    onClearChat: EventName<CustomEvent<void>>,
    onStartConversation: EventName<OramaChatCustomEvent<onStartConversationCallbackProps>>
};

export const OramaChat: StencilReactComponent<OramaChatElement, OramaChatEvents> = /*@__PURE__*/ createComponent<OramaChatElement, OramaChatEvents>({
    tagName: 'orama-chat',
    elementClass: OramaChatElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {
        onAnswerGenerated: 'answerGenerated',
        onClearChat: 'clearChat',
        onStartConversation: 'startConversation'
    } as OramaChatEvents,
    defineCustomElement: defineOramaChat
});

export type OramaChatAssistentMessageEvents = NonNullable<unknown>;

export const OramaChatAssistentMessage: StencilReactComponent<OramaChatAssistentMessageElement, OramaChatAssistentMessageEvents> = /*@__PURE__*/ createComponent<OramaChatAssistentMessageElement, OramaChatAssistentMessageEvents>({
    tagName: 'orama-chat-assistent-message',
    elementClass: OramaChatAssistentMessageElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaChatAssistentMessageEvents,
    defineCustomElement: defineOramaChatAssistentMessage
});

export type OramaChatBoxEvents = {
    onAnswerGenerated: EventName<OramaChatBoxCustomEvent<OnAnswerGeneratedCallbackProps>>,
    onClearChat: EventName<CustomEvent<void>>,
    onStartConversation: EventName<OramaChatBoxCustomEvent<onStartConversationCallbackProps>>,
    onAnswerSourceClick: EventName<OramaChatBoxCustomEvent<OnAnswerSourceClickCallbackProps>>,
    onChatMarkdownLinkClicked: EventName<OramaChatBoxCustomEvent<OnChatMarkdownLinkClickedCallbackProps>>
};

export const OramaChatBox: StencilReactComponent<OramaChatBoxElement, OramaChatBoxEvents> = /*@__PURE__*/ createComponent<OramaChatBoxElement, OramaChatBoxEvents>({
    tagName: 'orama-chat-box',
    elementClass: OramaChatBoxElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {
        onAnswerGenerated: 'answerGenerated',
        onClearChat: 'clearChat',
        onStartConversation: 'startConversation',
        onAnswerSourceClick: 'answerSourceClick',
        onChatMarkdownLinkClicked: 'chatMarkdownLinkClicked'
    } as OramaChatBoxEvents,
    defineCustomElement: defineOramaChatBox
});

export type OramaChatButtonEvents = NonNullable<unknown>;

export const OramaChatButton: StencilReactComponent<OramaChatButtonElement, OramaChatButtonEvents> = /*@__PURE__*/ createComponent<OramaChatButtonElement, OramaChatButtonEvents>({
    tagName: 'orama-chat-button',
    elementClass: OramaChatButtonElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaChatButtonEvents,
    defineCustomElement: defineOramaChatButton
});

export type OramaChatMessagesContainerEvents = { onAnswerGenerated: EventName<OramaChatMessagesContainerCustomEvent<OnAnswerGeneratedCallbackProps>> };

export const OramaChatMessagesContainer: StencilReactComponent<OramaChatMessagesContainerElement, OramaChatMessagesContainerEvents> = /*@__PURE__*/ createComponent<OramaChatMessagesContainerElement, OramaChatMessagesContainerEvents>({
    tagName: 'orama-chat-messages-container',
    elementClass: OramaChatMessagesContainerElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: { onAnswerGenerated: 'answerGenerated' } as OramaChatMessagesContainerEvents,
    defineCustomElement: defineOramaChatMessagesContainer
});

export type OramaChatUserMessageEvents = NonNullable<unknown>;

export const OramaChatUserMessage: StencilReactComponent<OramaChatUserMessageElement, OramaChatUserMessageEvents> = /*@__PURE__*/ createComponent<OramaChatUserMessageElement, OramaChatUserMessageEvents>({
    tagName: 'orama-chat-user-message',
    elementClass: OramaChatUserMessageElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaChatUserMessageEvents,
    defineCustomElement: defineOramaChatUserMessage
});

export type OramaDotsLoaderEvents = NonNullable<unknown>;

export const OramaDotsLoader: StencilReactComponent<OramaDotsLoaderElement, OramaDotsLoaderEvents> = /*@__PURE__*/ createComponent<OramaDotsLoaderElement, OramaDotsLoaderEvents>({
    tagName: 'orama-dots-loader',
    elementClass: OramaDotsLoaderElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaDotsLoaderEvents,
    defineCustomElement: defineOramaDotsLoader
});

export type OramaEmbedEvents = NonNullable<unknown>;

export const OramaEmbed: StencilReactComponent<OramaEmbedElement, OramaEmbedEvents> = /*@__PURE__*/ createComponent<OramaEmbedElement, OramaEmbedEvents>({
    tagName: 'orama-embed',
    elementClass: OramaEmbedElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaEmbedEvents,
    defineCustomElement: defineOramaEmbed
});

export type OramaFacetsEvents = NonNullable<unknown>;

export const OramaFacets: StencilReactComponent<OramaFacetsElement, OramaFacetsEvents> = /*@__PURE__*/ createComponent<OramaFacetsElement, OramaFacetsEvents>({
    tagName: 'orama-facets',
    elementClass: OramaFacetsElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaFacetsEvents,
    defineCustomElement: defineOramaFacets
});

export type OramaFooterEvents = NonNullable<unknown>;

export const OramaFooter: StencilReactComponent<OramaFooterElement, OramaFooterEvents> = /*@__PURE__*/ createComponent<OramaFooterElement, OramaFooterEvents>({
    tagName: 'orama-footer',
    elementClass: OramaFooterElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaFooterEvents,
    defineCustomElement: defineOramaFooter
});

export type OramaInputEvents = { onInputChanged: EventName<CustomEvent<string>> };

export const OramaInput: StencilReactComponent<OramaInputElement, OramaInputEvents> = /*@__PURE__*/ createComponent<OramaInputElement, OramaInputEvents>({
    tagName: 'orama-input',
    elementClass: OramaInputElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: { onInputChanged: 'inputChanged' } as OramaInputEvents,
    defineCustomElement: defineOramaInput
});

export type OramaLogoIconEvents = NonNullable<unknown>;

export const OramaLogoIcon: StencilReactComponent<OramaLogoIconElement, OramaLogoIconEvents> = /*@__PURE__*/ createComponent<OramaLogoIconElement, OramaLogoIconEvents>({
    tagName: 'orama-logo-icon',
    elementClass: OramaLogoIconElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaLogoIconEvents,
    defineCustomElement: defineOramaLogoIcon
});

export type OramaMarkdownEvents = { onChatMarkdownLinkClicked: EventName<OramaMarkdownCustomEvent<OnChatMarkdownLinkClickedCallbackProps>> };

export const OramaMarkdown: StencilReactComponent<OramaMarkdownElement, OramaMarkdownEvents> = /*@__PURE__*/ createComponent<OramaMarkdownElement, OramaMarkdownEvents>({
    tagName: 'orama-markdown',
    elementClass: OramaMarkdownElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: { onChatMarkdownLinkClicked: 'chatMarkdownLinkClicked' } as OramaMarkdownEvents,
    defineCustomElement: defineOramaMarkdown
});

export type OramaModalEvents = { onModalClosed: EventName<CustomEvent<any>> };

export const OramaModal: StencilReactComponent<OramaModalElement, OramaModalEvents> = /*@__PURE__*/ createComponent<OramaModalElement, OramaModalEvents>({
    tagName: 'orama-modal',
    elementClass: OramaModalElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: { onModalClosed: 'modalClosed' } as OramaModalEvents,
    defineCustomElement: defineOramaModal
});

export type OramaNavigationBarEvents = NonNullable<unknown>;

export const OramaNavigationBar: StencilReactComponent<OramaNavigationBarElement, OramaNavigationBarEvents> = /*@__PURE__*/ createComponent<OramaNavigationBarElement, OramaNavigationBarEvents>({
    tagName: 'orama-navigation-bar',
    elementClass: OramaNavigationBarElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaNavigationBarEvents,
    defineCustomElement: defineOramaNavigationBar
});

export type OramaSearchEvents = {
    onSearchCompleted: EventName<OramaSearchCustomEvent<OnSearchCompletedCallbackProps>>,
    onAnswerGenerated: EventName<OramaSearchCustomEvent<OnAnswerGeneratedCallbackProps>>
};

export const OramaSearch: StencilReactComponent<OramaSearchElement, OramaSearchEvents> = /*@__PURE__*/ createComponent<OramaSearchElement, OramaSearchEvents>({
    tagName: 'orama-search',
    elementClass: OramaSearchElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {
        onSearchCompleted: 'searchCompleted',
        onAnswerGenerated: 'answerGenerated'
    } as OramaSearchEvents,
    defineCustomElement: defineOramaSearch
});

export type OramaSearchBoxEvents = {
    onSearchCompleted: EventName<OramaSearchBoxCustomEvent<OnSearchCompletedCallbackProps>>,
    onSearchResultClick: EventName<OramaSearchBoxCustomEvent<OnSearchResultClickCallbackProps>>,
    onClearChat: EventName<CustomEvent<void>>,
    onStartConversation: EventName<OramaSearchBoxCustomEvent<onStartConversationCallbackProps>>,
    onAnswerGenerated: EventName<OramaSearchBoxCustomEvent<OnAnswerGeneratedCallbackProps>>,
    onAnswerSourceClick: EventName<OramaSearchBoxCustomEvent<OnAnswerSourceClickCallbackProps>>,
    onChatMarkdownLinkClicked: EventName<OramaSearchBoxCustomEvent<OnChatMarkdownLinkClickedCallbackProps>>,
    onModalClosed: EventName<CustomEvent<any>>,
    onModalStatusChanged: EventName<OramaSearchBoxCustomEvent<{ open: boolean; id: HTMLElement }>>
};

export const OramaSearchBox: StencilReactComponent<OramaSearchBoxElement, OramaSearchBoxEvents> = /*@__PURE__*/ createComponent<OramaSearchBoxElement, OramaSearchBoxEvents>({
    tagName: 'orama-search-box',
    elementClass: OramaSearchBoxElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {
        onSearchCompleted: 'searchCompleted',
        onSearchResultClick: 'searchResultClick',
        onClearChat: 'clearChat',
        onStartConversation: 'startConversation',
        onAnswerGenerated: 'answerGenerated',
        onAnswerSourceClick: 'answerSourceClick',
        onChatMarkdownLinkClicked: 'chatMarkdownLinkClicked',
        onModalClosed: 'modalClosed',
        onModalStatusChanged: 'modalStatusChanged'
    } as OramaSearchBoxEvents,
    defineCustomElement: defineOramaSearchBox
});

export type OramaSearchButtonEvents = NonNullable<unknown>;

export const OramaSearchButton: StencilReactComponent<OramaSearchButtonElement, OramaSearchButtonEvents> = /*@__PURE__*/ createComponent<OramaSearchButtonElement, OramaSearchButtonEvents>({
    tagName: 'orama-search-button',
    elementClass: OramaSearchButtonElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaSearchButtonEvents,
    defineCustomElement: defineOramaSearchButton
});

export type OramaSearchResultsEvents = { onSearchResultClick: EventName<OramaSearchResultsCustomEvent<OnSearchResultClickCallbackProps>> };

export const OramaSearchResults: StencilReactComponent<OramaSearchResultsElement, OramaSearchResultsEvents> = /*@__PURE__*/ createComponent<OramaSearchResultsElement, OramaSearchResultsEvents>({
    tagName: 'orama-search-results',
    elementClass: OramaSearchResultsElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: { onSearchResultClick: 'searchResultClick' } as OramaSearchResultsEvents,
    defineCustomElement: defineOramaSearchResults
});

export type OramaSlidingPanelEvents = NonNullable<unknown>;

export const OramaSlidingPanel: StencilReactComponent<OramaSlidingPanelElement, OramaSlidingPanelEvents> = /*@__PURE__*/ createComponent<OramaSlidingPanelElement, OramaSlidingPanelEvents>({
    tagName: 'orama-sliding-panel',
    elementClass: OramaSlidingPanelElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaSlidingPanelEvents,
    defineCustomElement: defineOramaSlidingPanel
});

export type OramaSourcesEvents = { onAnswerSourceClick: EventName<OramaSourcesCustomEvent<OnAnswerSourceClickCallbackProps>> };

export const OramaSources: StencilReactComponent<OramaSourcesElement, OramaSourcesEvents> = /*@__PURE__*/ createComponent<OramaSourcesElement, OramaSourcesEvents>({
    tagName: 'orama-sources',
    elementClass: OramaSourcesElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: { onAnswerSourceClick: 'answerSourceClick' } as OramaSourcesEvents,
    defineCustomElement: defineOramaSources
});

export type OramaSuggestionsEvents = NonNullable<unknown>;

export const OramaSuggestions: StencilReactComponent<OramaSuggestionsElement, OramaSuggestionsEvents> = /*@__PURE__*/ createComponent<OramaSuggestionsElement, OramaSuggestionsEvents>({
    tagName: 'orama-suggestions',
    elementClass: OramaSuggestionsElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaSuggestionsEvents,
    defineCustomElement: defineOramaSuggestions
});

export type OramaTextEvents = NonNullable<unknown>;

export const OramaText: StencilReactComponent<OramaTextElement, OramaTextEvents> = /*@__PURE__*/ createComponent<OramaTextElement, OramaTextEvents>({
    tagName: 'orama-text',
    elementClass: OramaTextElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaTextEvents,
    defineCustomElement: defineOramaText
});

export type OramaTextareaEvents = NonNullable<unknown>;

export const OramaTextarea: StencilReactComponent<OramaTextareaElement, OramaTextareaEvents> = /*@__PURE__*/ createComponent<OramaTextareaElement, OramaTextareaEvents>({
    tagName: 'orama-textarea',
    elementClass: OramaTextareaElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaTextareaEvents,
    defineCustomElement: defineOramaTextarea
});

export type OramaTogglerEvents = NonNullable<unknown>;

export const OramaToggler: StencilReactComponent<OramaTogglerElement, OramaTogglerEvents> = /*@__PURE__*/ createComponent<OramaTogglerElement, OramaTogglerEvents>({
    tagName: 'orama-toggler',
    elementClass: OramaTogglerElement,
    // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
    react: React,
    events: {} as OramaTogglerEvents,
    defineCustomElement: defineOramaToggler
});
